// TODO - remove lint disable when editing this file
/* eslint-disable */
import { hasIn } from 'lodash'
import AtomicBaseConverter from './AtomicBaseConverter'

export default class OembedConverter extends AtomicBaseConverter {
  constructor() {
    super('oembed_response', ['atomic-ellipsis.oembed_response'])
  }

  setMetaData(element, blocks, context) {
    // Unify additional_properties and alignment paths
    const unifiedElement = {
      ...element,
    }
    if (hasIn(element, 'raw_oembed.additional_properties')) {
      unifiedElement.additional_properties =
        element.raw_oembed.additional_properties
    }

    if (hasIn(element, 'raw_oembed.alignment')) {
      unifiedElement.alignment = element.raw_oembed.alignment
    }
    return super.setMetaData(unifiedElement, blocks, context)
  }
}
